import type { PositionWithOffsetValue } from '@elfsight/configurator-contracts';

export const positionMixin = ({
  position,
  verticalOffset,
  horizontalOffset
}: PositionWithOffsetValue) => {
  const positionMapping = {
    'top-left': {
      top: `${verticalOffset}px`,
      bottom: 'auto',
      left: `${horizontalOffset}px`,
      right: 'auto',
      translate: ''
    },
    top: {
      top: `${verticalOffset}px`,
      bottom: 'auto',
      left: 'auto',
      right: '50%',
      translate: '50%'
    },
    'top-right': {
      top: `${verticalOffset}px`,
      bottom: 'auto',
      left: 'auto',
      right: `${horizontalOffset}px`,
      translate: ''
    },
    right: {
      top: 'auto',
      bottom: '50%',
      left: 'auto',
      right: `${horizontalOffset}px`,
      translate: '0 50%'
    },
    'bottom-right': {
      top: 'auto',
      bottom: `${verticalOffset}px`,
      left: 'auto',
      right: `${horizontalOffset}px`,
      translate: ''
    },
    bottom: {
      top: 'auto',
      bottom: `${verticalOffset}px`,
      left: 'auto',
      right: '50%',
      translate: '50%'
    },
    'bottom-left': {
      top: 'auto',
      bottom: `${verticalOffset}px`,
      left: `${horizontalOffset}px`,
      right: 'auto',
      translate: ''
    },
    left: {
      top: 'auto',
      bottom: '50%',
      left: `${horizontalOffset}px`,
      right: 'auto',
      translate: '0 50%'
    },
    center: {
      top: '50%',
      bottom: 'auto',
      left: '50%',
      right: 'auto',
      translate: '-50% -50%'
    }
  };

  return {
    top: positionMapping[position].top,
    bottom: positionMapping[position].bottom,
    left: positionMapping[position].left,
    right: positionMapping[position].right,
    translate: positionMapping[position].translate
  };
};
